<script>
import {
  CdrLink,
  CdrCard,
  CdrText,
  CdrImg,
  CdrRating,
} from '@rei/cedar';

export default {
  name: 'LandingCard',
  components: {
    CdrLink,
    CdrCard,
    CdrText,
    CdrImg,
    CdrRating,
  },
  props: {
    card: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    baseClassName: 'ea-card',
    defaultAltText: 'Article image',
    loadImage: false,
  }),
  computed: {
    renderCard() {
      return this.card
        && this.card.uri
        && this.card.image
        && this.card.title
        && this.card.articleId
        && this.card.description
        && this.card.contentType;
    },
    hasRating() {
      return this.card.averageRating && this.card.reviewCount;
    },
  },
  methods: {
    getLinkName(name) {
      return `editors picks_${name}`;
    },
  },
};
</script>

<template>
  <cdr-card
    v-if="renderCard"
    :class="`${baseClassName}`"
  >
    <div>
      <cdr-img
        :src="card.image"
        :alt="card.imageAltText ?? defaultAltText"
        ratio="4-3"
        cover
      />
    </div>
    <div :class="`${baseClassName}__content`">
      <cdr-text
        data-test="type-label"
        :class="`${baseClassName}__eyebrow`"
      >
        {{ card.contentType }}
      </cdr-text>
      <cdr-link
        :href="card.uri"
        :data-analytics-id="getLinkName(card.title)"
        :class="`${baseClassName}__link`"
      >
        <cdr-text
          tag="h3"
          :class="`${baseClassName}__title`"
        >
          {{ card.title }}
        </cdr-text>
      </cdr-link>
      <cdr-rating
        v-if="hasRating"
        :rating="card.averageRating"
        :count="card.reviewCount"
        data-test="article-rating"
        size="small"
        :class="`${baseClassName}__rating`"
      />
      <cdr-text
        :class="`${baseClassName}__description`"
      >
        {{ card.description }}
      </cdr-text>
    </div>
  </cdr-card>
</template>

<style lang="scss">
  @import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

  $baseClassName: 'ea-card';

.#{$baseClassName} {
  .#{$baseClassName}__content {
    padding: $cdr-space-one-x;
  }
  .#{$baseClassName}__eyebrow {
    @include cdr-text-eyebrow-100;
    margin: $cdr-space-three-quarter-x 0 $cdr-space-eighth-x 0;
  }
  .#{$baseClassName}__title {
    @include cdr-text-heading-serif-500;
    margin: $cdr-space-one-x 0 $cdr-space-quarter-x 0;
  }
  .#{$baseClassName}__description {
    @include cdr-text-body-300;
    margin: $cdr-space-one-x 0;
  }
  .#{$baseClassName}__rating {
    margin-bottom: $cdr-space-three-quarter-x;
  }
}
</style>
